import { comparisonData } from '@/mocks/homeData';

const ComparisonSection = () => (
  <section id="comparacao" className="relative bg-background-50 py-16 md:py-24">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="text-center mb-14">
        <p className="text-xs font-semibold uppercase tracking-widest text-accent-600 mb-3">Comparação</p>
        <h2 className="text-4xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
          Hoobuy vs Outros
        </h2>
        <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
          Veja por que o nosso <strong>Hoobuy Spreadsheet</strong> é a melhor escolha para encontrar os produtos que você procura.
        </p>
      </div>

      <div className="max-w-2xl mx-auto bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
        <div className="grid grid-cols-3 bg-background-100 py-4 px-6">
          <span className="text-sm font-semibold text-foreground-800">Recurso</span>
          <span className="text-sm font-semibold text-foreground-800 text-center">Hoobuy</span>
          <span className="text-sm font-semibold text-foreground-800 text-center">Outros</span>
        </div>
        {comparisonData.map((row, i) => (
          <div
            key={row.feature}
            className={`grid grid-cols-3 py-4 px-6 ${
              i % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'
            }`}
          >
            <span className="text-sm text-foreground-700">{row.feature}</span>
            <span className="text-sm text-center">
              {Array.from({ length: 5 }).map((_, idx) => (
                <i
                  key={idx}
                  className={`ri-star-fill text-xs ${
                    idx < row.hoobuy ? 'text-accent-500' : 'text-foreground-300'
                  }`}
                ></i>
              ))}
            </span>
            <span className="text-sm text-center">
              {Array.from({ length: 5 }).map((_, idx) => (
                <i
                  key={idx}
                  className={`ri-star-fill text-xs ${
                    idx < row.outros ? 'text-secondary-500' : 'text-foreground-300'
                  }`}
                ></i>
              ))}
            </span>
          </div>
        ))}
      </div>

      <div className="mt-10 text-center">
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
        >
          Acessar Hoobuy Spreadsheet
          <i className="ri-arrow-right-line"></i>
        </a>
      </div>
    </div>
  </section>
);

export default ComparisonSection;